import { cn } from "@/lib/utils";
import { useConsumptions } from "@/stores/appStore";
import { useEffect, HTMLAttributes, useMemo } from "react";
import { Tip } from "@/components/fun-ui/Tip";
import { TokenIcon } from "@/components/fun-ui/icons";
import { replaceVariables } from "@/lib/replaceVariables";

type ConsumptionsProps = {
  scene: string | {
    label: string;
    price: number;
  };
  side?: "top" | "right" | "bottom" | "left";
  price?: number;
  amount?: number;
  increment?: number;
  triggerClassName?: string;
} & HTMLAttributes<HTMLDivElement>
export function Consumptions({
  scene,
  side = 'right',
  className = '',
  triggerClassName = '',
  price = -1,
  amount = 1,
  increment = 0,
}: ConsumptionsProps) {
  const {
    consumptions,
    initialConsumptions,
  } = useConsumptions();
  const current = useMemo(() => (
    typeof scene === 'string' ? (
      consumptions?.[scene]
    ) : scene
  ), [consumptions, scene]);

  const priceStr = useMemo(() => (
    price >= 0 ?
      (price + increment).toString() :
      (amount * (current?.price || 0) + increment).toString()
  ), [price, amount, current?.price, increment]);

  useEffect(() => {
    initialConsumptions();
  }, [initialConsumptions]);

  if (!current) {
    return <></>;
  }

  return (
    <div className={cn(
      "inline-block",
      className,
    )}>
      <Tip
        side={side}
        label={replaceVariables(current?.label, {
          price: priceStr,
        })}
      >
        <div className={cn(
          "flex items-center justify-center bg-muted rounded-full w-fit cursor-help h-6",
          "text-annotation-foreground pl-[6px] pr-2 py-1 space-x-[1px]",
          triggerClassName,
        )}>
          <TokenIcon size={14} />
          <span className="text-xs">×{priceStr}</span>
        </div>
      </Tip>
    </div>
  )
}
